var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStaked({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1057 9.17112C11.4487 7.61303 14.1063 7.19995 15.2 7.2C15.2 3.22355 11.7974 0 7.6 0C3.40264 0 0 3.22355 0 7.2C0 11.1764 3.40264 14.4 7.6 14.4C8.86201 14.4 10.0522 14.1086 11.0996 13.5929V10.3284C11.0734 10.3648 11.0445 10.3999 11.0128 10.4333C10.633 10.8343 10.0001 10.8514 9.59915 10.4715L6.91214 7.92595C6.7128 7.7371 6.59989 7.47459 6.59989 7.19999V3.59999C6.59989 3.04771 7.0476 2.59999 7.59989 2.59999C8.15217 2.59999 8.59989 3.04771 8.59989 3.59999V6.76986L10.9746 9.01962C11.0242 9.06656 11.0679 9.11737 11.1057 9.17112Z",
    fill: "#CCCDD4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5286 13.9145V15.843C11.5286 16.9082 13.5433 17.7716 16.0286 17.7716C18.5139 17.7716 20.5286 16.9082 20.5286 15.843V13.9145C20.5286 14.9796 18.5139 15.843 16.0286 15.843C13.5433 15.843 11.5286 14.9796 11.5286 13.9145Z",
    fill: "#CCCDD4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5286 10.7002V12.6287C11.5286 13.6939 13.5433 14.5573 16.0286 14.5573C18.5139 14.5573 20.5286 13.6939 20.5286 12.6287V10.7002C20.5286 11.7653 18.5139 12.6287 16.0286 12.6287C13.5433 12.6287 11.5286 11.7653 11.5286 10.7002Z",
    fill: "#CCCDD4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5286 9.41446C20.5286 10.4796 18.5139 11.343 16.0286 11.343C13.5433 11.343 11.5286 10.4796 11.5286 9.41446C11.5286 8.34933 13.5433 7.48588 16.0286 7.48588C18.5139 7.48588 20.5286 8.34933 20.5286 9.41446Z",
    fill: "#CCCDD4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaked);
export default __webpack_public_path__ + "static/media/staked.343f3a4d.svg";
export { ForwardRef as ReactComponent };